export default __webpack_public_path__ + "static/truth-24130f0a65d5e9479740097f53c091c5.jpg";